import React from "react";
import { View, TouchableOpacity } from "react-native";
import { Icon, Separator, Shadow, Text } from "component";

import { colors, sizes } from "asset/constant";
import { css } from "style";
import { mq } from "utils";
import { BallIndicator } from "react-native-indicators";

export default function ReloadCompaniesList(props: {
  onReload: () => void;
  loading?: boolean;
}) {
  const { onReload, loading } = props;

  return (
    <TouchableOpacity
      onPress={onReload}
      activeOpacity={sizes.tapOpacity}
      style={{
        margin: mq(5),
        height: mq(45),
        ...css.selfCenter,
        ...css.rRowCenterAlign,
      }}
    >
      <View>
        <View
          style={{
            ...css.circle(32),
            ...css.centralElements,
            ...css.bgColor(colors.white),
          }}
        >
          {loading ? (
            <BallIndicator color={colors.theme} size={mq(18)} />
          ) : (
            <Icon color={colors.theme} name="reload1" />
          )}
        </View>
      </View>
      <View style={{ top: mq(5) }}>
        <Text size={"lg"} weight="bold">
          برای بروزرسانی لیست شرکت‌ها کلیک کنید
        </Text>

        <Separator weight={mq(2)} sidesSpace={0} color={colors.black + "10"} />
      </View>
    </TouchableOpacity>
  );
}
